<template>
	<div class="food-bag" @click="tryBorrow"
		:class="{
			pulse : lowFood,
			empty : remainingFood === 0,
		}">
		<Vector :src="foodBagUrl" ref="foodbagSVG" class="foodbag-svg" v-if="foodBagUrl" />
		<div class="food-bag-ui">
			<span class="food-count" :style="{ color }"><AnimatedNumber :number="remainingFood" /></span>
			<span class="food-label">{{ scoopsText }}</span>
		</div>
		<transition name="fade-up" @after-enter="deactivateFoodMessage">
			<svg viewBox="0 0 200 45" class="foodbag-message" v-if="showFoodMessage">
				<path id="curve" d="M10,44.5S27.82,28,100,28s90,17,90,17" />
				<text width="200">
					<textPath class="no-food-message" xlink:href="#curve">Out Of Food</textPath>
					<!-- <textPath class="borrowed-message" xlink:href="#curve">Borrowed Food</textPath> -->
				</text>
			</svg>
		</transition>
	</div>
</template>

<script>
import AnimatedNumber from '@/components/abstract/AnimatedNumber';
import Vector from '@/components/abstract/Vector';
import soundFx from '@/mixins/sound-fx';
import { mapState, mapMutations } from 'vuex';
import { setElementStyles } from '@/mixins/element-attrs';

export default {
	name: 'FoodBag',
	mixins: [soundFx],
	components: {
		AnimatedNumber,
		Vector,
	},
	computed: {
		...mapState({
			remainingFood: state => state.food.remainingFood,
			hasBorrowedFood: state => state.food.hasBorrowedFood,
			showFoodMessage: state => state.food.showFoodMessage,
			scoopsText: state => state.config.general.scoops_text,
		}),
		lowFood() {
			return this.remainingFood <= 10;
		},
		color() {
			return this.lowFood ? "#ff4a4a" : "#ffffff";
		},
		foodBagUrl() {
			let url = false;

			if (this.$store.getters.currentStageSettings.food_bag_icon) {
				url = this.$store.getters.currentStageSettings.food_bag_icon.url;
			}

			return url;
		},
	},
	watch: {
		remainingFood(currentFood, formerFood) {
			if (currentFood > formerFood) {
				this.playRandomSound("food_refill");
			}

			const kibble = this.$refs.foodbagSVG.$el.querySelector("g#kibble");

			if (kibble) {
				if (currentFood <= 10) {
					const translateAmount = 38 - (currentFood * 2); // 38 = arbitrary max that looked good
					setElementStyles(kibble, { transform: `translate3d(0, ${translateAmount}px, 0)` });
				} else if (formerFood <= 10) {
					setElementStyles(kibble, { transform: `translate3d(0, 0, 0)` });
				}
			}
		},
	},
	methods: {
		...mapMutations([
			"deactivateFoodMessage",
		]),
		tryBorrow() {
			if (!this.hasBorrowedFood) {
				// commented out because never fully implemented ui for it
				// this.$store.dispatch("borrowFood");
			}
		},
	},
};
</script>

<style lang="scss" scoped>
	.food-bag {
		width: 166px;
		// height: 200px;
		position: relative;
		z-index: 10;

		&.pulse {
			animation: pulse .75s infinite;
		}

		@include mobile {
			width: 85px;
		}
	}

	.food-bag-svg {
		z-index: 1;
		position: relative;
	}

	.food-bag-ui {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;

		position: absolute;
		top: 32%;
		left: 0;
		right: 0;
		margin: 0 auto;
		z-index: 10;

		font-size: 22px;
		text-align: center;
		line-height: 2em;
		border-radius: 50%;

		@include mobile {
			top: 37.5%;
		}
	}

	.food-count {
		display: block;
		width: 2em;
		line-height: 1.3;
		font-size: 30px;
		font-weight: 500;

		@include mobile {
			font-size: 26px;
		}
	}

	.food-label {
		display: block;
		width: 4em;
		text-transform: uppercase;
		font-size: 12px;
		line-height: 1.3;
		font-weight: 700;
		letter-spacing: .03em;
		font-family: 'Asap Condensed';

		@include mobile {
			display: none;
		}
	}

	.foodbag-message {
		position: absolute;
		right: 0;
		bottom: 100%;
		left: 0;
		text-align: center;
		transition: all $ui-transition-duration;
		z-index: -1;

		#curve {
			fill: transparent;
		}

		text {
			text-transform: uppercase;
			fill: #fff;
			text-shadow: 1px 1px 2px $gray;
			font-weight: 700;
		}

		.no-food-message {
			font-size: 25px;
		}

		.borrowed-message {
			font-size: 23px;
		}
	}

	.foodbag-svg /deep/ #kibble {
		transition: all .2s;
	}
</style>



// WEBPACK FOOTER //
// src/components/board/FoodBag.vue